<template>
  <div class="bg-white rounded-lg shadow p-3 mb-6"  id="report-summary">
    <div class="flex flex-col p-4 items-center justify-center">
      <div class="w-full flex flex-col items-center justify-center">
        <h1 class="text-2xl font-semibold mb-2">Ingresos vs Gastos</h1>
        <Chart :options="chartOptions" />
      </div>
    </div>
  </div>
</template>

<script>
import numbers from "@/utils/numbers";
import { Chart } from "highcharts-vue";
export default {
  name: "SummaryReports",
  components: {
    Chart,
  },
  props: {
    // Example: Accept a prop to provide data as a decimal list
    monthsExpenses: {
      type: Array,
      default: () => [],
    },
    monthsIncomes: {
      type: Array,
      default: () => [],
    },
    widthChart: {
      type: Number,
      default: 600,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "line",
          height: 350, // altura base; el ancho será responsivo al contenedor
          width: this.widthChart, // ancho fijo en modo impresión
          reflow: true,
        },
        title: {
          text: null,
        },
        xAxis: {
          categories: this.monthNames(),
          title: {
            text: "Mes",
          },
        },
        yAxis: {
          title: {
            text: "Monto",
          },
        },
        tooltip: {
          shared: true,
          valuePrefix: "$",
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Ingresos",
            data: this.monthsIncomes,
            color: "#22c55e",
          },
          {
            name: "Gastos",
            data: this.monthsExpenses,
            color: "#ef4444",
          },
        ],
      },
    };
  },
  mounted() {
    // Puedes realizar cualquier lógica adicional aquí si es necesario
    this.updateChart();
  },
  computed: {},
  methods: {
    monthNames() {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return months.slice(0, this.monthsIncomes.length);
    },
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
  },
};
</script>

<style scoped>
.reports-index {
  margin-top: 40px;
}
</style>
